export enum Category {
    All = 'All',
    Alpha = 'Alpha',
    Beta = 'Beta',
    JensenAlpha = 'JensenAlpha',
    BattingAverage = 'BattingAverage',
    BestPeriod = 'BestPeriod',
    WorstPeriod = 'WorstPeriod',
    Kurtosis = 'Kurtosis',
    NumOfPositivePeriods = 'NumOfPositivePeriods',
    NumOfNegativePeriods = 'NumOfNegativePeriods',
    TotalNumOfPeriods = 'TotalNumOfPeriods',
    LongestPositivePeriod = 'LongestPositivePeriod',
    LongestNegativePeriod = 'LongestNegativePeriod',
    Skewness = 'Skewness',
    DownsideMarketCaptureRatio = 'DownsideMarketCaptureRatio',
    UpsideMarketCaptureRatio = 'UpsideMarketCaptureRatio',
    DownMarketReturn = 'DownMarketReturn',
    UpMarketReturn = 'UpMarketReturn',
    Bias = 'Bias',
    CalendarYearReturns = 'CalendarYearReturns',
    ExcessReturns = 'ExcessReturns',
    ExcessReturnsAnnualised = 'ExcessReturnsAnnualised',
    ExcessReturnsOverRF = 'ExcessReturnsOverRF',
    ExcessReturnsOverRFAnnualised = 'ExcessReturnsOverRFAnnualised',
    InformationRatio = 'InformationRatio',
    OmegaRatio = 'OmegaRatio',
    TrailingYearReturns = 'TrailingYearReturns',
    TrailingQuarterReturns = 'TrailingQuarterReturns',
    TrailingVolatility = 'TrailingVolatility',
    CumulativeReturn = 'CumulativeReturn',
    AnnualisedReturn = 'AnnualisedReturn',
    RiskFreeReturns = 'RiskFreeReturns',
    RollingAverage = 'RollingAverage',
    SharpeRatio = 'SharpeRatio',
    SortinoRatio = 'SortinoRatio',
    TrackingError = 'TrackingError',
    StandardDeviation = 'StandardDeviation',
    GainDeviation = 'GainDeviation',
    LossDeviation = 'LossDeviation',
    Drawdown = 'Drawdown',
    CalmarRatio = 'CalmarRatio',
    SterlingRatio = 'SterlingRatio',
    TreynorRatio = 'TreynorRatio',
    PortfolioCorrelationCovariance = 'PortfolioCorrelationCovariance',
    PortfolioReturns = 'PortfolioReturns',
    PortfolioExcessReturnsCorrelation = 'PortfolioExcessReturnsCorrelation',
    Forecast = 'Forecast',
    RSquared = 'RSquared',
    SeriesSplice = 'SeriesSplice',
}
